import { StarFilled } from '@ant-design/icons';
import { Checkbox } from 'antd';

import type { PackReviewItem } from 'app/typings/core/extranet/reviews/reviews';

import styles from './PackSelector.module.scss';

type PackSelectorProps = {
  pack: PackReviewItem;
  filterValue: number[];
  setFilterValue: (value: number[]) => void;
};

export const PackSelector = ({
  pack,
  filterValue,
  setFilterValue,
}: PackSelectorProps) => {
  const onChangeSelect = () => {
    if (filterValue.includes(pack.id)) {
      setFilterValue(filterValue.filter((filter) => filter !== pack.id));
    } else {
      setFilterValue([...filterValue, pack.id]);
    }
  };

  return (
    <div className={styles.packSelectorContainer}>
      <div className={styles.checkboxContainer}>
        <Checkbox
          checked={filterValue.includes(pack.id)}
          onChange={onChangeSelect}
        />
      </div>
      <div className={styles.packSelectorContent}>
        <div className={styles.packName}>{pack.nameForHotel}</div>
        <div className={styles.packRating}>
          <div className={styles.rating}>
            <StarFilled />
            <div>{Number(pack.averageScore?.toFixed(1))}</div>
          </div>
          <div className={styles.feedbacksCount}>({pack.feedbacksNumber})</div>
        </div>
      </div>
    </div>
  );
};
